import React from 'react';
import styled from 'styled-components';
import { colors } from '_styles';

const Ul = styled.ul`
    position: relative;
    width: 100%;
    margin: 0;
    padding: 13px 0px;
    box-sizing: border-box;
    list-style-type: none !important;
    min-height: 150px;
`;

const Li = styled.li``;

const Item = styled.button`
  border: none;
  background-color: transparent;
  font-size: 15px !important;
  color: ${colors.RC_ACTION} !important;
  line-height: 1.7em;
  text-align: left;
  display: block;
  cursor: pointer;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding: 7px 10px;
  width: 100%;
  text-decoration: none !important;
  border-radius: 3px;
  transition: 0.2s;
  
  &:hover {
    text-decoration: none !important;
    background-color: #EEEDEE;
    color: ${colors.RC_ACTION} !important;
  }
`;

const List = ({ address, onAddressItemClick }) => (
  <Ul>
    {
      address
        .filter((item, index) => index < 10)
        .map((item) => (
          <Li key={`${item.district_id}-${item.address.replaceAll(' ', '-')}`}>
            <Item
              onClick={() => onAddressItemClick(item)}
              //  alt={`click to confirm the ${item.address} as the selected zone`}
              title="Click to confirm area"
            >
              {item.address}
            </Item>
          </Li>
        ))
    }
  </Ul>
);

export default List;
